/**
 * 主催者(管理者)をプロフィール未登録でも表示するための既定値。
 *
 * 主催者はプロフィールを登録しなくてもルームを作成できるため、
 * 参加者から見たときに氏名が空になる。問い合わせ先として機能させるため、
 * 「管理者」という既定の表示に統一する。
 */
export const ROOM_OWNER_DEFAULT_NAME = '管理者'
export const ROOM_OWNER_ROLE_LABEL = 'イベント主催者'
export const ROOM_OWNER_DESCRIPTION =
  'このルームの主催者です。ご不明な点はこちらへお問い合わせください。'

/** 主催者の表示名を決める（登録名 → Google表示名 → 既定値 の順） */
export const resolveOwnerName = (
  registeredName?: string | null,
  username?: string | null,
): string => registeredName || username || ROOM_OWNER_DEFAULT_NAME
